/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-disable line-comment-position */

/** Podporované typy příkazů. */
export const commandTypeArray = /** @type {const} */ ([
  'deleteContent',
  'identify',
  'info',
  'lcd',
  'restart',
  'shutdown',
  'upgradeFirmware'
]);
